import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mt-s4 caption" }, "Wallet", -1)
const _hoisted_2 = { class: "ml-auto" }

import Icon from '@/components/Icon.vue';
import { useVesting } from '@/composables/core/useVesting';
import { useWallet } from '@/composables/core/useWallet';
import { useFormattedAddress } from '@/composables/utils/useFormattedAddress';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { address, network } = useWallet();
const { isNotListed, vestingStateIsReady } = useVesting();
const formattedAddress = useFormattedAddress(address, { flexSlicing: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", {
      class: _normalizeClass(["panel-data mt-s1 flex align-items-center justify-content-between", { 'panel-danger': _unref(vestingStateIsReady) && _unref(isNotListed) }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(
        _unref(vestingStateIsReady) && _unref(isNotListed) ? 'text-sm text-danger' : 'caption'
      )
      }, _toDisplayString(_unref(network).name), 3),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(formattedAddress)), 1),
      (_unref(vestingStateIsReady))
        ? (_openBlock(), _createBlock(Icon, {
            key: 0,
            name: _unref(isNotListed) ? 'danger' : 'successOutline',
            class: _normalizeClass(["ml-s2", _unref(isNotListed) ? 'text-danger' : 'text-success'])
          }, null, 8, ["name", "class"]))
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}
}

})